import React, { useState, useRef, useCallback }  from 'react';
// import ReactDOM from 'react-dom';
import './App.css';
// import LoginModal from './modal/LoginModal.js';
import * as utils from  './lib/mediaDeviceUtils.js';
import * as rtcUtils from  './lib/rtcUtils.js';
// import {useModal} from '@atlaskit/modal-dialog';
// import RoomSelectionModal from './modal/RoomSelectionModal.js';
import AvSettingModal from './modal/AvSettingModal.js';
import asyncModal from 'react-async-modal';
import 'react-responsive-modal/styles.css';
import packageJSON from '../package.json';
import StreamRecorder from './lib/StreamRecorder.js';
import exportRecordedBlob from './lib/exportRecordedBlob.js';

asyncModal.setDefaultModalProps({
  showCloseIcon: false,
  style: {
    modal: {
      width: 500
    }
  }
});

const initialState = {
  signalingServer: null,
  isLogin: false,
  isRoomSelected: false,
  localPeer: null,
  localVideo: null,
  localStream: new MediaStream(),
  remotePeer: null,
  remoteVideo: null,
  remoteStream: null,
};

const initialAvSettings = {
  videoInput: undefined,
  audioInput: undefined,
  audioOutput: undefined,
  audioGain: 100,
  deviceList: null,
  micTrack: null,
  cameraTrack: null
};

let recordedBlob = undefined;
let recorder = undefined;

function App() {
  const localVideo = useRef();
  const remoteVideo = useRef();
  const [isInitialized,setIsInitialized] = useState(false);
  const [state,setState] = useState(initialState);
  const [avSettings,setAvSettings] = useState(initialAvSettings);
  const [enableVideo,setEnableVideo] = useState(true);
  const [isRecording,setIsRecording] = useState(false);

  const constructor = async () => {
    if(isInitialized) return;

    console.log('CONSTRUCTOR');
    setIsInitialized(true);
 
    let tmpStream = null;  
    try {
      console.log('tmp getUserMedia()');
      tmpStream = await navigator.mediaDevices.getUserMedia({
        video: true, audio: true
      });
    } catch(err) {console.error(err);}
    console.log('tmp getUserMedia() complete');


    // Executed twice with "npm start". In different thread?
    // console.log(tmpStream.getTracks()); 

    if(localVideo.current) { /* to prevent the second  execution */
    try {

      tmpStream.getTracks().forEach ( (track) => {
        tmpStream.removeTrack(track); track.stop(); });
      } catch(err) {console.error(err);}

      await openAvSettings();  
    }

  }


  function setAudioGain(value) {
    console.log('App.setAudioGain: ', value);
  }

  async function setAudioOption(type, value){
    // console.log(type, value);
    try {
      const track = state.localStream.getAudioTracks()[0];
      await utils.setAudioTrackProperty(track,type,value);
    } catch(e){console.error(e);}
  }

  async function setMediaDevice(type, value){
    // console.log(type, value);

    const newAvSettings = avSettings;
    const {audioInput, videoInput, audioOutput} = avSettings;
    const {localStream, localPeer} = state;

    let update = false;
    if (type === 'audioInput' && value !== audioInput){
      newAvSettings.audioInput = value;


      try {
        update = true;
        localStream.getAudioTracks().forEach((track) => {
           localStream.removeTrack(track);  track.stop();});

        const micTrack = await utils.getMicTrack(value);
        localStream.addTrack(micTrack);
        console.log('micTrack added', micTrack);

        const newAvSettings = avSettings;
        newAvSettings.micTrack= micTrack; 
        setAvSettings(newAvSettings);

/*
        if(localPeer){
          const sender = localPeer.getSenders().find((s) => 
          s.track.kind === 'audio'); // not audioinput
          console.log('sender.replaceTrack', sender);
          sender.replaceTrack(micTrack);
        }
*/

      } catch(err) {console.error(err);}

    } else if (type === 'videoInput' && value !== videoInput){
      newAvSettings.videoInput = value;
      
      localStream.getVideoTracks().forEach((track) => {
        localStream.removeTrack(track);  
        track.stop();
      });

      try {
        update = true;

        const cameraTrack = await utils.getCameraTrack(value);
        console.log('cameraTrack', cameraTrack);

        localStream.addTrack(cameraTrack);

        const newAvSettings = avSettings;
        newAvSettings.cameraTrack= cameraTrack; 
        setAvSettings(newAvSettings);

/*
        if(localPeer){
          const sender = localPeer.getSenders().find( (s) => 
            s.track.kind === 'video');
          console.log('sender', sender);
          sender.replaceTrack(cameraTrack);
        }
*/

      } catch(err) {console.error(err);}
    }

    if(update || !localVideo.current.srCObject) {
      // localVideo.current.suspend();
      localVideo.current.srcObject = localStream;
      // localVideo.current.play();
    }

    if (type === 'audioOutput' && value !== audioOutput){
      newAvSettings.audioOutput = value;
      localVideo.current.setSinkId(value);
      remoteVideo.current.setSinkId(value);
    }

    setAvSettings(newAvSettings);
  }

  async function openAvSettings() {
    console.log('openAvSettings()');
    try {
      const deviceList = await utils.getListOfMediaDevices();
      //setAvDevices(deviceList);
      const newSetting = avSettings;
      newSetting.deviceList = deviceList;
      
      setAvSettings(newSetting);
    } catch(e) {console.error(e);}

    try {
      await asyncModal(AvSettingModal, { 
            avSettings: avSettings, // state
            setAudioGain: setAudioGain, // callback functions for Modal
            setAudioOption: setAudioOption, // cb
            setMediaDevice: setMediaDevice // cb
          });
    } catch(e) {console.error(e);}
 
  }

/*
  const loginHandler = useCallback((data) => {
    console.log(data);
  },[]);

  const roomHandler = useCallback((data) => {
    console.log(data);
  },[]);
*/

  const gotRemoteStreams = (streams) => {
  // called twice but no harm
    console.log('gotRemoteStreams', streams[0]);

    const newState = state;
    newState.remoteStream = streams[0];
    setState(newState);

    remoteVideo.current.volume = 1.0;
    remoteVideo.current.srcObject = streams[0];

    streams[0].onaddtrack = (event) => {
      remoteVideo.current.srcObject = streams[0];
    };

    streams[0].onremovetrack = (event) => {
      remoteVideo.current.srcObject = streams[0];
    };


  };

  const selectSignaling = async (e) => {
    const value = e.target.value;
    console.log('selectSignaling:', value);

    const newState = state;
    newState.signaling = value;
    setState(newState);

    if (value === 'local'){
      let retval = null;
      try {
        retval = await rtcUtils.localRTCPeerConnection(state.localStream,
          gotRemoteStreams); // give callback
      } catch (e) {console.error(e);}

      const newState = state;
      newState.localPeer = retval.localPeer;
      newState.remotePeer = retval.remotePeer;
      setState(newState);

    }

    if (value === 'server'){
      alert('Server connection not implemented yet');
    }

    if (value === 'close'){
      if (state.localPeer) state.localPeer.close();
      if (state.remotePeer) state.remotePeer.close();
      remoteVideo.current.pause();
      remoteVideo.current.srcObject = null;
    }
  
  };

//  const rooms = ['room0', 'room1', 'room2','room3']; 

  navigator.mediaDevices.ondevicechange = async (e) => {
    console.log('ondevicechange');
    await openAvSettings();
  }

  const switchVideo = (event) => {
    const {localPeer, localStream} = state;
    const {cameraTrack} = avSettings;

    if (enableVideo) { // turn off
      if(localPeer) {
        const sender = localPeer.getSenders().find((s) => {
            if(s.track && s.track.kind === 'video') 
              return true; 
            else return false;
          }
      ) ;
        if (sender) localPeer.removeTrack(sender);
      }
      cameraTrack.enabled = false;
    } else { // turn on
      cameraTrack.enabled = true;
      if(localPeer)
        localPeer.addTrack(cameraTrack, localStream);
    }

    setEnableVideo(!enableVideo); // toggle state
  }

  const recordRemoteVideo = async (event) => {

    if (isRecording) {
      if (recorder) {
        recordedBlob = await recorder.stop();
      }

      if (recordedBlob){
        const seconds = Math.floor(Date.now()/1000);
        exportRecordedBlob(recordedBlob, 'remote_' + seconds)
      }

    } else {
      recordedBlob = null;
      if (state.remoteStream) {
        recorder = new StreamRecorder(state.remoteStream);
        recorder.start();
      }
    }
    setIsRecording(!isRecording);
  };

  constructor(); // start program

  return (
    <div className="App">
     Connect: 
     <span onChange={selectSignaling} defaultValue='close'>
     <label><input name="signaling" type="radio" value="local" />
       Local</label>&nbsp;
     <label><input name="signaling" type="radio" value="server" />
       Server</label>&nbsp;
     <label><input name="signaling" type="radio" value="close" />
       Close</label>&emsp;
     </span>
     <button onClick={openAvSettings}>AVSettings</button>&emsp;
     <button onClick={switchVideo}>
     { enableVideo ? 'Disable Video' : 'Enable Video'} </button>
     &emsp;
     <button onClick={recordRemoteVideo}>{isRecording ? 'Stop' : 'Record'}
     </button>
    <hr/>
    <video ref={localVideo} controls autoPlay playsInline muted
     style={{width: '30%'}} />
    &emsp;
    <video ref={remoteVideo} controls autoPlay playsInline
      style={{width: '50%'}} />
    <hr />
    Version: {packageJSON.version}
    <hr />
    </div>
  );
}

export default App;
